module.exports = __webpack_public_path__ + "img/news 3.501015f3.png";